import { I18N } from "aurelia-i18n";
import { BindingEngine, computedFrom } from "aurelia-binding";
import { MenuItem } from "../../../../../components/menu/menu-item";
import { MobileHelper } from "../../../../../../helpers/mobile-helper";
import { Container, autoinject, transient } from "aurelia-dependency-injection";
import { CustomGridPageBase } from "../../../../common/custom-grid-page.base";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { DataGridColumn, DataType, QueryFilter, SourceType } from "../../../../../../models/queries/queries.models";
import { useView } from "aurelia-framework";

@autoinject()
@transient()
@useView('views/pages/modules/rules/tabs/rule-collections/rule-collections.html')
export class RuleCollections extends CustomGridPageBase {
 
    public initialFilters: QueryFilter[];
    private odataUrl = "odata/RuleCollections";
    public selectedFilter: { title: string, clear: () => void, apply: () => void };
    public isMobileFilterOpen: boolean = false;
    public mobileSelectedfilters : any[] = []
    public isColumnFiltering: boolean = false;

    constructor(i18N: I18N, 
        protected bindingEngine: BindingEngine,
        private dialogClient: DialogClientService) {
        super(i18N, 'Lists', bindingEngine);
        
    }

    activate() {
        this.columns = this.getColumns();
        this.itemSource = this.getItemSource([]);
    }

    getColumns(): DataGridColumn[] {
        return  [
            {
                dataType: DataType.CustomTemplate,
                value: `<check-box checked.bind="getRowItem() && getRowItem().isSelected"
                        changed.delegate="getDataGrid().selectRowInMultipleSelection(getRowItem())">
                    </check-box>`,
                name: "select",
                title: MobileHelper.isMobileDevice() ? "" : `<check-box class="check-box-select-all" checked.two-way="toggleAll"></check-box>`,
                parameter: {
                    item: null
                },
                instancePerRow: true,
                sortOrder: 1,
                columnOrder: -2,
                width: "38px",
                isHidden: false,
                isSortable: false,
                getCellClass: () => {
                    return "selector-checkbox";
                }
            },
            {
                dataType:  DataType.CustomTemplate,
                name:  "name",
                title:  "Name",
                value: (item, row, column, dataGridVM) => {
                    if (item && dataGridVM) {
                        const dialogClient = Container.instance.get(DialogClientService);
                        dialogClient.show(RightShipDialogServiceConstants.URLs.AddRulesCollectionDialog, {
                            dataGrid: dataGridVM,
                            ruleCollectionId: item.id
                        }, true, false, false, 'right');
                    }
                    return '<div class="row"><a click.trigger="getDataGrid().handleClickOnButton($event,getRowItem(),getRowItem().columnKeys[`name`].column)" class="link" href="#">${item.name}</a>'
                    +'<comp-icon ref="itemid" class="icon-doc-lines" icon="doc-lines" if.bind="item.notes"></comp-icon>'
                    + '<comp-tooltip on-element.bind="itemid" show-arrow="true" if.bind="item.notes">${item.notes}</comp-tooltip>'
                    + '</div>';
                },
                instancePerRow:  true,
                sortOrder:  1,
                columnOrder:  -1,
                isHidden:  false,
                isSortable:  true,
                width:  "150px",
                parameter: {
                    item: null
                }
            },
            {
                sortOrder:  3,
                columnOrder:  3,
                name:  "type",
                dataType:  DataType.Default,
                title:  "Type",
                isFilterable:  false,
                disableSorting:  true,
                isSortable:  false
            },
            {
                sortOrder:  4,
                columnOrder:  4,
                name:  "ruleCount",
                dataType:  DataType.Default,
                title:  "Rule Count",
                isFilterable:  false,
                disableSorting:  true,
                isSortable:  false
            },
            {
                sortOrder:  5,
                columnOrder:  5,
                name:  "childRuleCollections",
                dataType:  DataType.Default,
                title:  "Child Rule Collections",
                isFilterable:  false,
                disableSorting:  true,
                isSortable:  false
            },
            {
                dataType:  DataType.Default,
                name:  "createdBy",
                title:  "Created By",
                sortOrder:  7,
                columnOrder:  7,
                isHidden:  false,
                isSortable:  true,
                width:  "150px"
            },
            {
                dataType:  DataType.Boolean,
                name:  "isActive",
                title:  "Is Active",
                sortOrder:  9,
                columnOrder:  9,
                isHidden:  false,
                isSortable:  true,
                width:  "100px"
            },
            {
                dataType:  DataType.Boolean,
                name:  "rightStoreActive",
                title:  "RightStore Active",
                sortOrder:  9,
                columnOrder:  9,
                isHidden:  false,
                isSortable:  true,
                width:  "100px"
            },
            {
                columnOrder: 99,
                sortOrder: 99,
                dataType: DataType.CustomTemplate,
                instancePerRow: true,
                name: "menu",
                value: `<div class="actions row justify-content-end align-items-middle">
                                <list-menu hide-menu-border="true" menu-items.bind="menuItems(item, getDataGrid())" if.bind="menuItems(item, getDataGrid()).length > 0">
                                    <template replace-part="menu-item">
                                        <div class="row nowrap align-items-middle">
                                            <span class="text">\${menuItem.item.text}</span>
                                        </div>  
                                    </template>
                                </list-menu>
                            </div>`,
                parameter: {
                    item: null,
                    menuItems: (item, dataGridVM) => {
                        const menuItems: MenuItem[] = [];
                        menuItems.push({
                            isVisible: true, click: () => this.dialogClient.show(RightShipDialogServiceConstants.URLs.RuleCollectionAuditDialog,
                                { ruleCollectionId: item.id }, true, false, false, 'right'), item: { text: "Audit" }, classList: ''
                        }),
                        menuItems.push({
                            isVisible: true, click: () => this.dialogClient.show(RightShipDialogServiceConstants.URLs.ViewRulesDialog,
                                { ruleCollectionId: item.id }, true, false, false, 'right'), item: { text: "View rules" }, classList: ''
                        }),
                        menuItems.push({
                            isVisible: true, click: () => this.dialogClient.show(RightShipDialogServiceConstants.URLs.AddRightStoreSetup,
                                { ruleCollectionId: item.id, ruleCollectionName: item.displayName, rightStoreSetupId: item.ruleCollectionRightStoreSetupId, onSaved: () => { dataGridVM.reloadData()} }, true, false, false, 'right'), 
                                item: { text: `${item.ruleCollectionRightStoreSetupId > 0? 'Edit': 'Add'} Rule Collection Setup` }, classList: ''
                        });
                        return menuItems;
                    }
                }
                }
        ];
    }

    private getItemSource(filters) {
        this.initialFilters = filters;
        return {
            sourceType: SourceType.ODataUrl,
            source: this.odataUrl,
            columns: this.columns,
            initialFilters: this.initialFilters,
            initialSorting: this.initialSorting
        };
    }

    closeAllFilters() {
        this.showNameFilter = false;
    }

    private setItemSource() { 
        const currentFilters: QueryFilter[] = []; 

        //name filter
        if(this.nameFilterActive) {
            currentFilters.push(QueryFilter.getQuery("name", this.name, "contains({0}, '{1}')", DataType.Default,false,false,null,false,true))
        }

        this.itemSource = this.getItemSource(currentFilters);
    }

    public get isSubFilterOpen(): boolean {
        return this.showNameFilter;
    }

    //#region Name filter
    public name : string = ""
    public showNameFilter: boolean;
    public nameIsApplied: boolean;
    toggleNameFilter() {
        if(!this.showNameFilter) {
            this.closeAllFilters();
        }
        this.showNameFilter = !this.showNameFilter;
    }
    public nameSetSelectedFilter() {
        this.selectedFilter = {
            title: "Name",
            clear: () => {
                this.clearNameFilter();
            },
            apply: () => {
                this.showNameFilter = false;
            }
        }
    }
    public clearNameFilter() {
        this.name = ""
        this.nameIsApplied = false;
        this.setItemSource();
    }
    public applyNameFilter() {
        
        this.setItemSource();
        this.showNameFilter = false;
    }
    @computedFrom("name") 
    public get nameFilterActive() : boolean {
        return this.name && this.name.length > 0;
    }
    //#endregion

     //#region column sorting 
     public showColumnSorting: boolean = false;
     public selectedColumnSorting: number[] = [];
 
     public toggleColumnSortingFilters() {
         if (!this.showColumnSorting) {
             this.closeAllFilters();
         }
         this.showColumnSorting = !this.showColumnSorting;
         this.selectedFilter = {
             title: "Column sorting",
             clear: () => { 
             },
             apply: () => {
                 this.applyColumnSortingFilter(this.selectedColumnSorting.map((bId: number) => {
                     return { id: bId };
                 }), false);
             }
         }
     }
 
     public applyColumnSortingFilter(items: any[], reload: boolean = true) {
         this.selectedColumnSorting = items.map(x => x.id);
         if (reload == true) this.setItemSource();
         this.toggleColumnSortingFilters();
     }
 
     sortByMobile(column: DataGridColumn) {
         this.dataGridVM.sortingTriggered(column);
         this.isColumnFiltering = this.dataGridVM.visibleColumns.some(item => item.isAscending === true || item.isAscending === false);
     }
 
     sortClass(column: DataGridColumn) {
         if (column.isAscending) {
             return "Ascending"
         }
         else if (column.isAscending == false) {
             return "Descending"
         }
         else {
             return "";
         }
     }
 
     //#endregion

    toggleMobileFilterDialog() {
        if (!this.isSubFilterOpen) {
            this.isMobileFilterOpen = !this.isMobileFilterOpen;
        }
        this.showNameFilter = false;
    }
    public mobileApplyAllFilters(toggleDialog: boolean = true) {
        if(toggleDialog)
            this.toggleMobileFilterDialog();
        // this.selectedStatusFilter = [];
        this.mobileSelectedfilters.forEach(x => {
            x.apply();
        })
        //Refresh itemSource irrelevant of number of mobileSelectedFilters. Users may unselect all filters (resulting in no selected filters)
        this.setItemSource();
        this.mobileSelectedfilters = []
    }
    hideMobileFilters() {
        this.isMobileFilterOpen = false;    
    }
    public mobileAddSelectedFilter() {
        if (this.selectedFilter) {
            this.mobileSelectedfilters.push(this.selectedFilter)
            this.selectedFilter = null;
        }
    }

    public clearAllFilters() { 
        if(this.dataGridVM) {
            this.dataGridVM.clearSorting();
            this.isColumnFiltering = false;
        }
        this.clearNameFilter();
    }
}